import styled from 'styled-components/macro'
import breakpoints from 'assets/stylesheet'

const SearchFilter = styled.div`
  font-size: 22px;
  color: #4a4a4a;
  text-align: left;
  border: 0;
  width: 390px;
  transition: all 0.4s ease;
  left: ${props => (props.open ? '380px' : '-20px')};
  top: ${props => (props.customTop ? props.customTop : '-57px')};
  @media (max-width: ${breakpoints.bpTabletPx}) {
    width: 100%;
    left: 0;
    top: 0;
    z-index: 10;
    display: ${props => (props.open ? 'block' : 'none')};
    opacity: 1 !important;
    transition: none;
    position: relative;
  }
`

export default SearchFilter
